/**
 * Joshua Alele-Beals
 * joshbeals22@gmail.com
 * github.com/joshBeals
 */

function capitalizeFirst(string){
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export default capitalizeFirst;